import { redirectUrl, serviceKey } from "../config";
import { firebase, googleAuthProvider } from "../firebase/firebase";
import Cookies from "js-cookie";
import { getCookieDomain } from "../utils/helper";

export const login = (uid) => {
  return {
    type: "LOGIN",
    uid: uid,
  };
};

export const startLogin = () => {
  return (dispatch) => {
    return firebase
      .auth()
      .signInWithPopup(googleAuthProvider)
      .catch(() => {
        //Ignore
      });
  };
};

export const setLoggingIn = (truth) => {
  return {
    type: "SET_LOGGING_IN",
    truth: truth,
  };
};

export const logout = () => {
  return {
    type: "LOGOUT",
  };
};

export const startLogout = () => {
  return (dispatch) => {
    const cookieDomain = getCookieDomain();

    // Remove all cookies for the current domain
    Object.keys(Cookies.get()).forEach((cookieName) => {
      Cookies.remove(cookieName, {
        path: "/",
        domain: cookieDomain, // ✅ ensure domain matches how it was set
      });

      // Fallback in case cookie was set without domain
      Cookies.remove(cookieName, {
        path: "/",
      });
    });

    // Optional: dispatch logout state if needed
    // dispatch(logout());

    // Redirect to another domain or page
    window.location.href = `${redirectUrl}?pid=${serviceKey}`;
  };
};
